export default {
    root: ({ props }) => ({
        class: [
            'textarea-input-placeholder-text textarea-root',

            { 'textarea-root_invalid': props.invalid },
        ],
    }),
};
